// VideoContent.jsx
import React, { useState, useEffect } from "react";

function isYouTubeUrl(url) {
  return /youtu\.be|youtube\.com/.test(url);
}

function getYouTubeEmbedUrl(url) {
  try {
    const u = new URL(url);
    let id = "";

    if (u.hostname.includes("youtu.be")) {
      id = u.pathname.replace("/", "");
    } else if (u.searchParams.get("v")) {
      id = u.searchParams.get("v") || "";
    } else if (u.pathname.startsWith("/embed/")) {
      id = u.pathname.replace("/embed/", "");
    }

    if (!id) return url;
    return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
  } catch (e) {
    return url;
  }
}

export default function VideoContent(props) {
  const {
    videoUrl,
    thumbnailSrc,
    title = "Video",
    className = "",
    label,
  } = props;
  const [isPlaying, setIsPlaying] = useState(false);

  // 🔥 IMPORTANT: reset when video URL changes
  useEffect(() => {
    setIsPlaying(false);
  }, [videoUrl]);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const isYouTube = isYouTubeUrl(videoUrl);
  const autoplayUrl = isYouTube ? getYouTubeEmbedUrl(videoUrl) : videoUrl;

  return (
    <div
      className={
        "relative aspect-video w-full overflow-hidden rounded-xl bg-black " +
        className
      }
    >
      {/* Optional label above video if you want */}
      {label && !isPlaying && (
        <div className="absolute top-2 left-2 z-10 text-xs sm:text-sm bg-black/60 text-white px-2 py-1 rounded">
          {label}
        </div>
      )}

      {isPlaying ? (
        isYouTube ? (
          <iframe
            src={autoplayUrl}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="h-full w-full border-0"
          />
        ) : (
          <video
            src={autoplayUrl}
            autoPlay
            controls
            className="h-full w-full"
          />
        )
      ) : thumbnailSrc ? (
        <button
          type="button"
          onClick={handlePlay}
          className="group relative h-full w-full"
        >
          <img
            src={thumbnailSrc}
            alt={title}
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40 transition group-hover:bg-black/30" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/90 shadow-lg transition group-hover:scale-105 group-hover:bg-white">
              <span className="ml-0.5 inline-block border-y-[8px] border-l-[14px] border-y-transparent border-l-black" />
            </div>
          </div>
        </button>
      ) : (
        <div
          className="flex flex-col justify-center items-center h-full w-full"
          onClick={handlePlay}
        >
          <div className="flex justify-center items-center h-16">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-10 h-10 text-red-500"
            >
              <path
                fillRule="evenodd"
                d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <p className=" text-xs font-medium text-white">
            Click to Watch Video
          </p>
        </div>
      )}
    </div>
  );
}
